import UFOSegment from "@atlassian/wac-ufo-segment";

import GlobalFooterPattern from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import {
    Cards,
    Careers,
    Carousel,
    Hero,
    LiftedBanner,
    SocialProof
} from "./sections";

export const HomePageTemplate = () => {
    return (
        <UFOSegment name="home-page">
            <div>
                <GlobalNavigation showTryNow={true} productKey={"home"} />
                <Hero />
                <LiftedBanner />
                <Carousel />
                <SocialProof />
                <Cards />
                <Careers />
                <GlobalFooterPattern />
            </div>
        </UFOSegment>
    );
};
